import { __assign } from "tslib";
import { parseImageName, parseWidthHeight } from './stringUtils';
export function getFullImageDescriptor(descriptor) {
    try {
        // save source ratio
        var autoTargetHeight = descriptor.targetHeight
            ? descriptor.targetHeight
            : (descriptor.targetWidth / descriptor.sourceWidth) *
                descriptor.sourceHeight;
        if ('relativeUrl' in descriptor) {
            return __assign(__assign({}, descriptor), { targetHeight: autoTargetHeight });
        }
        return __assign(__assign({}, descriptor), { targetHeight: autoTargetHeight, relativeUrl: parseImageName(descriptor.url), sourceWidth: descriptor.sourceWidth || parseWidthHeight(descriptor.url).width, sourceHeight: descriptor.sourceHeight || parseWidthHeight(descriptor.url).height });
    }
    catch (e) {
        console.log('Error in getFullImageDescriptor', e);
    }
}
//# sourceMappingURL=getFullImageDescriptor.js.map